import mutations from './linkUser.mutations';
import actions from './linkUser.actions';
import initialState from './linkUser.state';

export default {
  state: initialState,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/linkUser/linkUser.module.js